import formatNumber from 'Helper/formatNumber';
import { isEmpty } from 'lodash';

const getAchievementRankResponse = (response, metric) => {
  const brandAchievement = response?.brandAchievement;
  const isCurrency = metric?.value?.toLowerCase() === 'aov';
  const userData = !isEmpty(response?.yourRank)
    ? {
        ...response?.yourRank,
        isCurrency,
      }
    : {};
  const achievementRank = {
    ...response,
    userData,
    rankingData: response?.topThree?.length
      ? response?.topThree?.map((item) => {
          return {
            hostName: item?.name,
            value: item?.avgValue,
            isCurrency,
          };
        })
      : [],
    targetProgress: {
      brandRevenue: {
        target: brandAchievement?.targetGmv,
        progress: brandAchievement?.actualGmv,
        progressPercentage:
          brandAchievement?.actualGmv && brandAchievement?.targetGmv ? formatNumber((brandAchievement?.actualGmv / brandAchievement?.targetGmv) * 100) : 0,
        isCurrency,
      },
      viewsBrand: {
        target: brandAchievement?.targetViews,
        progress: brandAchievement?.actualViews,
        progressPercentage:
          brandAchievement?.actualViews && brandAchievement?.targetViews
            ? formatNumber((brandAchievement?.actualViews / brandAchievement?.targetViews) * 100)
            : 0,
      },
      ctr: {
        target: brandAchievement?.targetCtr,
        progress: brandAchievement?.actualCtr,
        progressPercentage:
          brandAchievement?.actualCtr && brandAchievement?.targetCtr ? formatNumber((brandAchievement?.actualCtr / brandAchievement?.targetCtr) * 100) : 0,
        uom: '%',
        uomPosition: 'right',
      },
      ctor: {
        target: brandAchievement?.targetCtor,
        progress: brandAchievement?.actualCtor,
        progressPercentage:
          brandAchievement?.actualCtor && brandAchievement?.targetCtor ? formatNumber((brandAchievement?.actualCtor / brandAchievement?.targetCtor) * 100) : 0,
        uom: '%',
        uomPosition: 'right',
      },
      err: {
        target: brandAchievement?.targetErr,
        progress: brandAchievement?.actualErr,
        progressPercentage:
          brandAchievement?.actualErr && brandAchievement?.targetErr ? formatNumber((brandAchievement?.actualErr / brandAchievement?.targetErr) * 100) : 0,
        uom: '%',
        uomPosition: 'right',
      },
      aov: {
        target: brandAchievement?.targetAov,
        progress: brandAchievement?.actualAov,
        progressPercentage:
          brandAchievement?.actualAov && brandAchievement?.targetAov ? formatNumber((brandAchievement?.actualAov / brandAchievement?.targetAov) * 100) : 0,
        isCurrency,
      },
      totalLiveDuration: brandAchievement?.totalDuration,
      totalLiveSession: brandAchievement?.totalLive,
    },
  };
  return achievementRank;
};

export default getAchievementRankResponse;
